// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__pKEsP","card":"Cards_card__XfxAV","infected":"Cards_infected__pVrGa","recovered":"Cards_recovered__XkzbD","deaths":"Cards_deaths__dlCIu"};